import PropTypes from "prop-types";
import { childrenPropType } from "../../common";

/**
 * PropTypes for AdminRoute component
 *
 * @property {React.ReactNode} children - Route content to render if authorized
 * @property {string} [redirectTo] - Path to redirect if unauthorized
 */
export const adminRoutePropTypes = {
  children: childrenPropType,
  redirectTo: PropTypes.string,
};
